var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSurveys = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H11C12.6569 0 14 1.34315 14 3V4.92031C13.9236 4.98297 13.8495 5.04998 13.7782 5.12133L12 6.89951V3C12 2.44772 11.5523 2 11 2H3C2.44772 2 2 2.44772 2 3V15C2 15.5523 2.44772 16 3 16H11C11.4157 16 11.7722 15.7464 11.923 15.3854C12.0785 15.2801 12.2263 15.1585 12.364 15.0208L14 13.3848V15C14 16.6569 12.6569 18 11 18H3C1.34315 18 0 16.6569 0 15V3ZM4 5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H5C4.44772 6 4 5.55228 4 5ZM4 9C4 8.44771 4.44772 8 5 8H9C9.55228 8 10 8.44771 10 9C10 9.55229 9.55228 10 9 10H5C4.44772 10 4 9.55229 4 9ZM10.2426 11.4853L15.1924 6.53554C15.5829 6.14502 16.2161 6.14502 16.6066 6.53554C16.9971 6.92607 16.9971 7.55923 16.6066 7.94976L11.6569 12.8995L9.53554 13.6066L10.2426 11.4853ZM5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14H6C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12H5Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSurveys, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/surveys.54faa53b.svg";
export { ForwardRef as ReactComponent };